import { fetcherConfig } from '../../lib/api-fetcher';
import { z } from 'zod';
import { createResourceClient, normalizeVersionedPath } from '@repo/api-client';
import { getAccessToken } from '../../lib/session';
import { type AuditEventListItem, type AuditEventDetail } from './types';


const auditEventListItemObject = z.object({
  id: z.string(),
  occurredAt: z.string(),
  actorId: z.string().nullable(),
  actorAudience: z.enum(['staff', 'agent', 'customer', 'system']),
  eventType: z.string(),
  resourceType: z.string().nullable(),
  resourceId: z.string().nullable(),
  summary: z.string().optional().nullable().transform((val) => val ?? ''),
  ipAddress: z.string().nullable(),
});

const auditEventDetailObject = auditEventListItemObject.extend({
  payload: z.record(z.string(), z.any()),
  userAgent: z.string().nullable(),
});

const auditEventListItemSchema: z.ZodType<AuditEventListItem> = auditEventListItemObject;
const auditEventDetailSchema: z.ZodType<AuditEventDetail> = auditEventDetailObject;

// Audit is read-only — no create/update operations
export const auditClient = createResourceClient<AuditEventListItem, AuditEventDetail, never, never>(
  fetcherConfig,
  {
    path: '/staff/v1/audit/events',
    schemas: {
      listItem: auditEventListItemSchema,
      detail: auditEventDetailSchema,
      create: z.never(),
      update: z.never(),
    },
  }
);

export async function exportAuditEvents(params: Record<string, string | number>) {
  const query = new URLSearchParams(params as Record<string, string>).toString();
  const token = getAccessToken();
  const response = await fetch(`${fetcherConfig.baseUrl}${normalizeVersionedPath('/staff/v1/audit/events/export')}?${query}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error('Failed to export audit events');
  }
  return response.json() as Promise<{ data: { jobRef: string } }>;
}
